import {
  Tab as ChakraTab,
  Table,
  TableContainer,
  TabPanel,
  Tbody,
  Td,
  Tfoot,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { styles } from '@ui/components/TanstackTable';
import { useQuoteLineContext } from '@ui/features/quote-builder/components/QuoteLine/QuoteLineProvider';
import { actions } from '@ui/features/quote-builder/state/reducer';
import { selectQuoteLineWithLeadTimeIssues } from '@ui/features/quote-builder/state/selectors/quote-line';
import { QuoteInfoTab } from '@ui/features/quote-builder/types/state/quote-line';
import { useDispatch } from '@ui/hooks/useDispatch';
import { useSelector } from '@ui/hooks/useSelector';
import {
  decimalToCurrency,
  decimalToPercent,
} from '@ui/util/decimal-transforms';

import { TabComponentType } from '../types';
import { extractValueFromResultsMetadata } from './extract-values';
import { priceSegmentNames } from './price-segment-names';

const tab = QuoteInfoTab.PriceSegments;

function Tab() {
  const dispatch = useDispatch();
  const { quoteLineUuid } = useQuoteLineContext();

  function handleTabChange() {
    dispatch(actions.quoteLineInfoTabChanged({ quoteLineUuid, tab }));
  }

  return <ChakraTab onClick={handleTabChange}>Price Segments</ChakraTab>;
}

function Panel() {
  const { quoteLineUuid } = useQuoteLineContext();
  const { priceSegments, priceAdjustmentAmount, priceAdjustment } = useSelector(
    (state) => selectQuoteLineWithLeadTimeIssues(state, quoteLineUuid),
  );

  return (
    <TabPanel width="100%" overflow="hidden">
      <TableContainer>
        <Table sx={styles}>
          <Thead>
            <Tr>
              <Th>Segment</Th>
              <Th>Matched</Th>
              <Th>Adjustment</Th>
            </Tr>
          </Thead>
          <Tbody>
            {priceSegments.map((priceSegment) => (
              <Tr key={priceSegment.uuid}>
                <Td>{priceSegmentNames[priceSegment.segment]}</Td>
                <Td>
                  {extractValueFromResultsMetadata(
                    priceSegment.resultsMetadata,
                  )}
                </Td>
                <Td>{decimalToPercent(priceSegment.priceAdjustment)}</Td>
              </Tr>
            ))}
          </Tbody>
          <Tfoot>
            <Tr>
              <Td colSpan={2}>
                <b>Total Adjustment Percent</b>
              </Td>
              <Td>
                <b>{decimalToPercent(priceAdjustment)}</b>
              </Td>
            </Tr>
            <Tr>
              <Td colSpan={2}>
                <b>Unit Price Adjustment</b>
              </Td>
              <Td>
                <b>{decimalToCurrency(priceAdjustmentAmount)}</b>
              </Td>
            </Tr>
          </Tfoot>
        </Table>
      </TableContainer>
    </TabPanel>
  );
}

export const PriceSegments = {
  tab,
  Tab,
  Panel,
} satisfies TabComponentType;
